import * as Custom from "../provider/custom";
import * as Posthog from "../provider/posthog";
import type { AnalyticsProviderModule } from "./provider-contract";

const REGISTRY: Record<string, AnalyticsProviderModule> = {
	custom: Custom,
	posthog: Posthog,
};

/** Resolve registry key: explicit env wins; otherwise prefer PostHog when a project key is set. */
function resolvedRegistryKey(): string {
	const explicit = process.env.NEXT_PUBLIC_ANALYTICS_PROVIDER?.trim();
	if (explicit === "custom" || explicit === "posthog") {
		return explicit;
	}
	if (explicit) {
		return explicit;
	}
	return process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim() ? "posthog" : "custom";
}

function resolveActiveProvider(): AnalyticsProviderModule {
	const key = resolvedRegistryKey();
	const mod = REGISTRY[key];
	if (mod?.isConfigured()) {
		return mod;
	}
	return REGISTRY.custom;
}

/** Active analytics backend for this build (env + `isConfigured()`); falls back to no-op `custom`. */
export const ActiveAnalyticsProvider: AnalyticsProviderModule =
	resolveActiveProvider();
